import { getCookie } from 'libs/utils/cookies';
export function getConsentGroups() {
  var _optanonConsentCookie;

  const optanonConsentCookie = new URLSearchParams(getCookie('OptanonConsent'));
  return ((_optanonConsentCookie = optanonConsentCookie.get('groups')) === null || _optanonConsentCookie === void 0 ? void 0 : _optanonConsentCookie.split(',')) || [];
} // This only captures the current cookie value. useIsConsentGroupEnabled hook should be used in most cases

export function checkConsentGroup(group) {
  return getConsentGroups().includes(group);
}